import Api from './api';

const slug = 'locales';
export default {
  getLocale(locale) {
    return new Promise((resolve, reject) => {
      Api.get(`/${slug}/${locale}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};
